// extracted by mini-css-extract-plugin
module.exports = {"inputs":"datosPersonales_inputs__3cN4z","labels":"datosPersonales_labels__31hAu","requiredFieldStar":"datosPersonales_requiredFieldStar__2JH9Z"};